/**
 * This component is used as part of any input in the form design system to render the label
 * For better performance, it should be rendered conditionally based on the label prop if it exists
 */
import { type ReactNode } from "react";
import { cn } from "~/design-system/lib/utils";
import { HelpIcon } from "../../icons";
import { Tooltip } from "../../ui";

export type InputLabelProps = {
  children: ReactNode;
  htmlFor?: string;
  required?: boolean;
  className?: string;
  onClick?: () => void;
  help?: ReactNode;
  classes?: {
    container?: string;
    tooltip?: string;
  };
};

export function InputLabel({
  htmlFor,
  className,
  required,
  children,
  help,
  classes,
  ...props
}: InputLabelProps) {
  return (
    <>
      {children && (
        <div className={cn("pb-3", className)}>
          <label
            htmlFor={htmlFor}
            className="flex gap-1 font-medium text-mine-shaft fluid-text-lg"
            {...props}
          >
            {children}
            {required && <span className="ms-1 text-red-700">*</span>}
            {help && (
              <Tooltip component={<HelpIcon />} text={help} classes={classes} />
            )}
          </label>
        </div>
      )}
    </>
  );
}
